import { useContext, useEffect, useRef, useState } from "react";
import SetTemprature from "../../constants/SetTemprature";
import TempratureChanges from "../../constants/TempratureChanges";
import { Context } from "../../context/Context";
import { UpdateScenarioCommand } from "../../api/api";

const ThermostatSetTempModal = ({
  changeButton,
  setChangeButton,
  buttonStates,
  setButtonStates,
  selectValue,
  changeTemp,
  setChangeTemp,
}) => {
  const { setThermostatSetTempModal, thermostatSetTempModalType } =
    useContext(Context);
  const [value, setValue] = useState(selectValue);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setThermostatSetTempModal(modalName);
  }, []);

  const renderOptionsOfSelect = () => {
    if (thermostatSetTempModalType == 1) {
      // Set Temprature
      return SetTemprature.map((temp, index) => {
        if (temp.value == selectValue) {
          return (
            <option value={temp.value ?? ''} key={index} selected="selected">
              {temp.name}
            </option>
          );
        }
        return <option value={temp.value ?? ''} key={index}>{temp.name}</option>;
      });
    } else if (thermostatSetTempModalType == 2) {
      // Temprature Changes
      return TempratureChanges.map((chng, index) => {
        if (chng.value == selectValue) {
          return (
            <option value={chng.value ?? ''} key={index} selected="selected">
              {chng.name}
            </option>
          );
        }
        return <option value={chng.value ?? ''} key={index}>{chng.name}</option>;
      });
    }
  };

  const handleSubmit = () => {
    if (thermostatSetTempModalType == 1) {
      if (buttonStates[changeButton.device_id] !== undefined) {
        setButtonStates((prev) => ({
          ...prev,
          [changeButton.device_id]: {
            ...prev[changeButton.device_id], // Copy the current state for the device
            [changeButton.digit + 1]: {
              ...prev[changeButton.device_id][changeButton.digit + 1], // Copy the current state for the button digit
              setting_temp: value, // Update the specific value
            },
          },
        }));
        setChangeTemp(!changeTemp);
      }
    } else if (thermostatSetTempModalType == 2) {
      if (buttonStates[changeButton.device_id] !== undefined) {
        setButtonStates((prev) => ({
          ...prev,
          [changeButton.device_id]: {
            ...prev[changeButton.device_id], // Copy the current state for the device
            [changeButton.digit + 1]: {
              ...prev[changeButton.device_id][changeButton.digit + 1], // Copy the current state for the button digit
              change_temp: value, // Update the specific value
            },
          },
        }));
        setChangeTemp(!changeTemp);
      }
    }
    closeButton.current.click();
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="scenarioTimerModal"
      tabIndex="-1"
      aria-labelledby="scenarioTimerModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              {thermostatSetTempModalType == 1
                ? "دمای تنظیم (C°)"
                : "تغییرات دما (C°)"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <select
                id="timerSelect"
                className="form-select w-100"
                data-style="btn-default"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              >
                {renderOptionsOfSelect()}
              </select>
            </div>
            <div>
              
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
                type="button"
                className="btn btn-success-app me-3 mb-2"
                onClick={handleSubmit}
              >
                ثبت
              </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThermostatSetTempModal;
